$(function(){
  $('[data-js="slider"]').slick({
    centerMode: true,
    autoplay: false,
    slidesToShow: 4,
    centerPadding: 0,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          centerMode: true,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 300,
          slidesToShow: 3,
          arrows: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 1000,
        }
      }
    ]
  });

  //slick起動後に高さをそろえる。
  $('.c-cardAnchor__inner').matchHeight();
  //レスポンシブ
  $('[data-js="slider"]').on('breakpoint', function(event, slick, breakpoint){
    $('.c-cardAnchor__inner').matchHeight();
  });


  //モーダル
  $('.c-gallery__btn').magnificPopup({
    type: 'inline',
    preloader: false,
    showCloseBtn: false,
    callbacks: {
      open: function() {
        modalGallery();
      },
      close: function() {
        $('[data-js="modal-slider"]').slick('unslick');
      }
    }
  });
  //閉じるリンクの設定
  $(document).on('click', '.c-gallery__modal-close', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  //モーダルスライダー定義
  function modalGallery() {
    $('[data-js="modal-slider"]').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: true
    });
  }

});